{
  "username": "Username",
  "password": "Password",
  "signIn": "Sign In",
  "ams": "Attribute Management Studio",
  "atb": "Attribute Toolbox",
  "signInImage": "Sign In Image",
  "experianLogo": "Experian Logo",
  "incorrectUsernamePassword":"Username or Password Incorrect",
  "loginFail": "Login Failed, please check your credentials and try again."
}
